// Клиент `GET /api/v1/tasks/{id}/acceptance` — каноничное чтение
// acceptance-критериев задачи, не зависящее от жизни pending-плана.

import { apiErrorFromResponse } from "../../api/apiError";
import { authedFetch } from "../../auth/authedFetch";

// Зеркало backend/modules/task/schemas/acceptance.py::AcceptanceItemResponse.
export type AcceptanceStatus = "pending" | "done" | "na";
export type AcceptanceSource = "orchestrator" | "user";

export interface AcceptanceItemResponse {
  readonly id: string;
  readonly text: string;
  readonly status: AcceptanceStatus;
  readonly source: AcceptanceSource;
}

// Порядок массива = порядок пунктов. 404 `task_not_found` и прочие
// отказы — `ApiError`.
export async function fetchTaskAcceptance(
  taskId: string,
): Promise<AcceptanceItemResponse[]> {
  const response = await authedFetch(`/api/v1/tasks/${taskId}/acceptance`, {
    headers: { Accept: "application/json" },
  });
  if (!response.ok) {
    throw await apiErrorFromResponse(response, "task acceptance");
  }
  return (await response.json()) as AcceptanceItemResponse[];
}
